import { Injectable } from '@angular/core';

import { getUserInfoAdminMock } from '@pt/mocks';
import { delay, Observable, of } from 'rxjs';

import { getMemberCoursesMock } from '../mocks';
import { GetUserInfoRes } from '../models';
import { GetMemberCoursesRes } from '../models/get-member-courses';
import { CoursesReportApi } from './courses-report-api.interface';

@Injectable()
export class CoursesReportApiMock implements CoursesReportApi {
  getUserInfo(): Observable<GetUserInfoRes> {
    return of(getUserInfoAdminMock()).pipe(delay(500));
  }

  getMemberCourses(): Observable<GetMemberCoursesRes> {
    return of(getMemberCoursesMock()).pipe(delay(500));
  }
}
